import React from 'react';
import { calculateTotalOvertimeHours, calculateTotalFineHours } from '../../utils/helper';

const Summary = ({ attendance }) => {
  return (
    <div className="flex flex-wrap gap-[18px] mt-[16px] whitespace-nowrap summaryrecord">
      <SummaryItem title="Total Staff" value={attendance?.length} />
      <SummaryItem title="Present" value={attendance?.filter(item => item?.punchRecord?.[0]?.status === "PRESENT").length} />
      <SummaryItem title="Absent" value={attendance?.filter(item => item?.punchRecord?.[0]?.status === "ABSENT").length} />
      <SummaryItem title="Half Day" value={attendance?.filter(item => item?.punchRecord?.[0]?.status === "HALFDAY").length} />
      <SummaryItem title="Overtime Hours" value={attendance?.length ? calculateTotalOvertimeHours(attendance) : 0} />
      <SummaryItem title="Fine Hours" value={attendance?.length ? calculateTotalFineHours(attendance) : 0} />
      <SummaryItem title="Paid Leave" value={attendance?.filter(item => item?.punchRecord?.[0]?.status === "PAIDLEAVE").length} />
    </div>
  );
};

const SummaryItem = ({ title, value }) => (
  <div className="total-staff">
    <h2 className="font-normal text-[#000000bf] text-[14px]">{title}</h2>
    <p className="font-semibold text-[14px]">{value}</p>
  </div>
);

export default Summary;
